import { DEFAULT_EDIT_PLAYLIST_ROUTES } from './defaultRoutes';
export function getTabLink(_ref) {
  var tabName = _ref.tabName,
    _ref$routes = _ref.routes,
    routes = _ref$routes === void 0 ? DEFAULT_EDIT_PLAYLIST_ROUTES : _ref$routes;
  var tabRouteMap = {
    details: routes.singlePlaylistDetails,
    content: routes.singlePlaylistContent,
    contentPreview: routes.singlePlaylistContentPreview,
    access: routes.singlePlaylistAccess,
    share: routes.singlePlaylistShare,
    analytics: routes.singlePlaylistAnalytics
  };
  return tabRouteMap[tabName] || routes.singlePlaylistDetails;
}